module.exports = __webpack_public_path__ + "img/toutou_song_cover.bf2966eb.jpg";